/**
 * Servicio para Scouts (Captación)
 * 
 * Endpoints:
 * - GET /api/postgres/scouts/activos - Lista de scouts activos (para dropdown tutor)
 * - GET /api/postgres/scouts - Lista completa con conteo (admin)
 * - GET /api/postgres/scouts/:id - Detalle de scout (admin)
 * - POST /api/postgres/scouts - Crear scout (admin)
 * - PUT /api/postgres/scouts/:id - Editar scout (admin)
 */

import api from './api';

class ScoutService {

  /**
   * Obtener lista de scouts activos (para el dropdown del tutor)
   * @returns {Array} Lista de scouts activos [{id, nombre}]
   */
  static async getScoutsActivos() {
    try {
      const response = await api.get('/postgres/scouts/activos');
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error('No se pudo obtener scouts activos');
    } catch (error) {
      console.error('❌ Error al obtener scouts activos:', error);
      throw error;
    }
  }

  /**
   * Obtener lista completa de scouts con conteo de captados (admin)
   * @param {number} organizacionId - ID de la organización
   * @returns {Array} Lista de scouts con total_captados
   */
  static async getScouts(organizacionId) {
    try {
      const response = await api.get('/postgres/scouts', {
        params: { organizacion_id: organizacionId }
      });
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error('No se pudo obtener scouts');
    } catch (error) {
      console.error('❌ Error al obtener scouts:', error);
      throw error;
    }
  }

  /**
   * Obtener detalle de un scout con sus futbolistas captados (admin)
   * @param {number} scoutId
   * @returns {Object} Scout con lista de futbolistas
   */
  static async getScoutById(scoutId) {
    try {
      const response = await api.get(`/postgres/scouts/${scoutId}`);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error('No se pudo obtener detalle del scout');
    } catch (error) {
      console.error('❌ Error al obtener scout:', error);
      throw error;
    }
  }

  /**
   * Crear un nuevo scout (admin)
   * @param {Object} data - { nombre, telefono, email, notas, organizacion_id }
   * @returns {Object} Scout creado
   */
  static async createScout(data) {
    try {
      const response = await api.post('/postgres/scouts', data);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error('No se pudo crear el scout');
    } catch (error) {
      console.error('❌ Error al crear scout:', error);
      throw error;
    }
  }

  /**
   * Actualizar un scout (admin)
   * @param {number} scoutId
   * @param {Object} data - { nombre, telefono, email, notas, activo }
   * @returns {Object} Scout actualizado
   */
  static async updateScout(scoutId, data) {
    try {
      const response = await api.put(`/postgres/scouts/${scoutId}`, data);
      if (response.data.success) {
        return response.data.data;
      }
      throw new Error('No se pudo actualizar el scout');
    } catch (error) {
      console.error('❌ Error al actualizar scout:', error);
      throw error;
    }
  }

  /**
   * Reporte de captación - futbolistas por origen (admin)
   * @returns {Object} { total, resumen, data }
   */
  static async getReporteCaptacion() {
    try {
      const response = await api.get('/postgres/scouts/report/captacion');
      if (response.data.success) {
        return response.data;
      }
      throw new Error('No se pudo obtener reporte de captación');
    } catch (error) {
      console.error('❌ Error al obtener reporte de captación:', error);
      throw error;
    }
  }
}

export default ScoutService;
